const ResumeIcon = () => {
  return (
    <svg
      width="33"
      height="41"
      viewBox="0 0 33 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.62597 28.564H27.424M5.62597 33.844H27.424M16.4439 15.0437C20.5456 15.0437 22.8348 17.3719 23.7802 20.9806C23.9375 21.5812 23.4631 22.1425 22.8423 22.1425H9.66273C9.04088 22.1425 8.56724 21.5787 8.75137 20.9848C9.73298 17.8183 12.404 15.0437 16.4439 15.0437ZM4.97656 40.0928H28.0273C30.2365 40.0928 32.0273 38.3019 32.0273 36.0928V4.90625C32.0273 2.69711 30.2365 0.90625 28.0273 0.90625H4.97656C2.76742 0.90625 0.976562 2.69711 0.976562 4.90625V36.0928C0.976562 38.3019 2.76742 40.0928 4.97656 40.0928Z"
        stroke="#004FC6"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
      <circle
        cx="16.498"
        cy="10.8184"
        r="4.21836"
        stroke="#004FC6"
        strokeWidth="1.7"
      />
    </svg>
  );
};

export default ResumeIcon;
